export class UserChallengeEnum {
  static NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
  static SMS_MFA = 'SMS_MFA';
  static SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA';
  static MFA_SETU = 'MFA_SETU';
  static RESET_REQUIRED = 'RESET_REQUIRED';
}
